/**
 * Versioned assumptions for the roof, panel, energy and finance model.
 *
 * This module is the single owner of the values used by both the 2D siting
 * calculation and the 3D panel preview. Changing an assumption is a model
 * change: bump MODEL_VERSION and update docs/FORMULAS.md.
 */
export const MODEL_VERSION = 'solar-v1.1';

/** Fraction of the measured roof area available for panel packing. */
export const USABLE_FRACTION = 0.85;
export const PANEL_WIDTH_M = 2.384;
export const PANEL_HEIGHT_M = 1.303;
export const PANEL_KWP = 0.725;
export const STOREY_HEIGHT_M = 3.0;
export const INSTALL_COST_USD_PER_KWP = 750;
export const TARIFF_USD_PER_KWH = 0.16;
export const CO2_T_PER_MWH = 0.4;
export const YIELD_PER_KWP = 1750;
/** Long-standing national fallback used when no per-site PVOUT is available. */
export const DEFAULT_YIELD_PER_KWP = YIELD_PER_KWP;
export const PANEL_AREA_M2 = PANEL_WIDTH_M * PANEL_HEIGHT_M;
export const AREA_PER_KWP_M2 = PANEL_AREA_M2 / PANEL_KWP;
